import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import withToggle, { InjectedToggleProps } from '../hocs/withToggle'

import Button            from '@material-ui/core/Button'
import Dialog            from '@material-ui/core/Dialog'
import DialogActions     from '@material-ui/core/DialogActions'
import DialogContent     from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle       from '@material-ui/core/DialogTitle'
import Grid              from '@material-ui/core/Grid'
import Slide             from '@material-ui/core/Slide'
import ErrorOutline      from '@material-ui/icons/ErrorOutline'

const UpSlide = props => <Slide direction={'up'} {...props} />

interface ClickPromptProps {
  header: React.ReactNode
  subheader?: React.ReactNode
}

type Props =
  ClickPromptProps
  & InjectedToggleProps

const ClickPrompt: React.SFC<Props> = ({
  isActive,
  activate,
  deactivate,
  header,
  subheader,
  children,
}) => {
  const clickable = React.cloneElement(children as React.ReactElement<any>)

  const handleConsent = () => {
    deactivate()
    clickable.props.onClick()
  }

  const interceptedClickable = React.cloneElement(
    clickable,
    { onClick: activate },
  )

  return (
    <>
      {interceptedClickable}
      <Dialog
        open={isActive}
        TransitionComponent={UpSlide}
      >
        <DialogTitle>
          <Grid container spacing={16} alignItems={'center'}>
            <Grid item>
              {header}
            </Grid>
            <Grid item>
              <ErrorOutline color={'error'} />
            </Grid>
          </Grid>
        </DialogTitle>
        {subheader && (
          <DialogContent>
            <DialogContentText>
              {subheader}
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={handleConsent} color={'primary'}>
            <FormattedMessage id={'dictionary.yes'} />
          </Button>
          <Button onClick={deactivate} color={'primary'}>
            <FormattedMessage id={'dictionary.no'} />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default withToggle(ClickPrompt)



// WEBPACK FOOTER //
// ./src/components/atoms/ClickPrompt.tsx